import React from 'react';
import { Snackbar } from '@mui/material';
import { useTranslation } from './LocalizationProvider';
import { snackBarDurationLongMs } from '../util/duration';

const SuccessDialog = ({
  open,
}) => {
  const t = useTranslation();
  return (
    <Snackbar
      open={open}
      autoHideDuration={snackBarDurationLongMs}
      message={t('successTitle')}
    />
  );
};

export default SuccessDialog;
